import React, { useEffect, useState } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import useSocket from "use-socket.io-client";
import clsx from "clsx";
import {
  useAppEvenListSelector,
  useAppEventGameDetailSelector,
  useAppEventGameListSelector,
  useAppGameDetailsSelector,
  useAppNextEventRouteSelector,
  useAppPickIdsSelector,
  useAppRodeoEventLoginRequiredSelector,
} from "src/_common/hooks/selectors/eventSelector";
import { useEventApi } from "src/_common/hooks/actions/event/appEventApiHook";
import { useAppEventAction } from "src/_common/hooks/actions/event/appEventActionHook";
import { useAppUserAction } from "src/_common/hooks/actions/user/appUserActionHook";
import { useAppGuestUserIdSelector, useAppUserDetailsSelector } from "src/_common/hooks/selectors/userSelector";
import {
  CRYPTO_SECRET_KEY,
  getEventStatusText,
  removeTrailingZero,
  RODEPICK_NEXT_GAME_IDS,
  SOCKET_CHANNEL,
  SOCKET_URL,
  trimTo,
  URLS,
} from "src/_config";
import { toast } from "react-toastify";
import RiderSelectionModal from "../modal/riderSelectionModal";
import GuestSaveVoteModal from "../modal/guestSaveVoteModal";
import StatusModal from "../modal/statusModal";
import GeoLocation from "src/components/common/GeoLocation";
import PickedTeamModal from "../modal/pickedTeamModal";
import Sponsor from "src/components/common/Sponsor";
import ShareModal from "../modal/shareModal";
import FanMagazineModal from "../modal/FanMagazineModal";

const Cryptr = require("cryptr");
const cryptr = new Cryptr(CRYPTO_SECRET_KEY);

export default function RodeoRidersPage() {
  const eventApi = useEventApi();
  const history = useHistory();
  const eventAction = useAppEventAction();
  const userAction = useAppUserAction();
  const userDetails = useAppUserDetailsSelector();
  const fromRoute = useAppNextEventRouteSelector();
  const { eventId, performanceId, gameId } = useParams<any>();
  const e_id: number = parseInt(cryptr.decrypt(eventId));
  const p_id: number = parseInt(cryptr.decrypt(performanceId));
  const g_id: number = parseInt(cryptr.decrypt(gameId));
  // const eventGameDetailsSelector = useAppEventGameDetailSelector();
  const [eventGameDetailsSelector, setEventGameDetailsSelector] = useState<any>();
  const [showRiderSelectionModal, setRiderSelectionModal] = useState<boolean>(false);
  const [showGuestSaveVoteModal, setShowGuestSaveVoteModal] = useState<boolean>(false);
  const [selectedRider, setSelectedRider] = useState<any>();
  const eventListSelector = useAppEvenListSelector();
  const guestUserId = useAppGuestUserIdSelector();
  const [nextGameIds, setNextGameIds] = useState<any>([]);
  const pick_id = useAppPickIdsSelector();
  const [nextGameArrayIndex, setNextGameArrayIndex] = useState<any>();
  // const loginReq = useAppRodeoEventLoginRequiredSelector()
  const [loginReq, setLoginReq] = useState<any>(0);
  const [winnerDeclared, setWinnerDeclared] = useState<any>(0);
  const [showStatusModal, setShowStatusModal] = useState<boolean>(false);
  const [statusModalMesssage, setStatusModalMesssage] = useState<any>();
  const [pickStatus, setPickStatus] = useState<any>();
  const gameDetails = useAppGameDetailsSelector();
  const [riderSelectionModalClosed, setRiderSelectionModalClosed] = useState<boolean>(false);
  const [showPickedTeamModal, setShowPickedTeamModal] = useState<boolean>(false);
  const [congratsShown, setCongratsShown] = useState<boolean>(false);
  const [teamDetails, setTeamDetails] = useState<any>();
  const [tieBreakerCode, setTieBreakerCode] = useState<any>();
  const eventGameListSelector = useAppEventGameListSelector();
  const [performanceDetails, setPerformanceDetails] = useState<any>();
  const [showShareModal, setShowShareModal] = useState<boolean>(false);
  const [showFanMagModal, setShowFanMagModal] = useState<boolean>(false);
  const [url, setUrl] = useState<any>();
  const [contestWinData, setContestWinData] = useState<any>();

  const submitVoteForRider = () => {
    let params: any = {
      event_id: g_id,
      rodeo_event_id: e_id,
      performance_id: p_id,
      rider_id: selectedRider && selectedRider.id,
    };
    if (guestUserId) {
      params["guest_user_id"] = guestUserId;
    }

    let geoId = localStorage.getItem("geolocation_val");
    if (geoId) {
      params["location_id"] = geoId;
    } else {
      params["location_id"] = null;
    }
    let lat = localStorage.getItem("latitude");
    let lng = localStorage.getItem("longitude");
    params["lat"] = lat;
    params["lng"] = lng;

    eventApi.callPickRider(
      params,
      (message: string, resp: any) => {
        if (resp) {
          closeRiderSelectionModal();
          userAction.guestUserId(resp);
          if (resp.guest_user_id) {
            localStorage.setItem("guestUserId", resp.guest_user_id);
          } else {
            localStorage.removeItem("guestUserId");
          }
          if (resp.tie_breaker_code) {
            setTieBreakerCode(resp.tie_breaker_code);
          }
          // getEventGameDetails(resp.guest_user_id)
          setTimeout(() => setRiderSelectionModalClosed(true), 500);
          toast.success(message);
        }
      },
      (message: string) => {
        closeRiderSelectionModal();
        toast.error(message);
      }
    );
  };

  const getYouPicks = () => {
    let params: any = {
      rodeo_event_id: e_id,
      performance_id: p_id,
    };
    if (guestUserId) {
      params["guest_user_id"] = guestUserId;
    }
    eventApi.callYourPicks(
      params,
      (message: string, resp: any) => {
        if (resp) {
          console.log({ resp });
          setPerformanceDetails(resp?.performance);
          setTeamDetails(resp?.team);
        }
      },
      (message: string) => {
        toast.error(message);
      }
    );
  };

  // const getMyTeam = () => {
  //     let params = {
  //         rodeo_event_id: parseInt(cryptr.decrypt(eventId))
  //     }
  //     // console.log({params})
  //     eventApi.callGetMyTeam(
  //         params,
  //         (message: any, resp: any)=>{
  //             console.log({resp})
  //             let team = resp?.performance?.find((x:any)=>x.id==p_id)?.my_teams
  //             setTeamDetails(team)
  //             // setResults(resp)
  //         },
  //         (message: any)=>{

  //         }
  //     )
  // }

  const onStatusModalClose = () => {
    setShowStatusModal(false);
  };

  // Vote Rider Modal relaed functionality start here
  const openRiderSelectionModal = (e: any, rider: any) => {
    e && e.preventDefault();
    // if (eventGameDetailsSelector && eventGameDetailsSelector.events && eventGameDetailsSelector.events.ispicked) {
    //     return;
    // } else
    if (eventGameDetailsSelector.events.ispicked && eventGameDetailsSelector.events.ispicked.rider_id === rider.id) {
      return;
    }
    console.log({ rider });
    if (winnerDeclared == "1") {
      setShowStatusModal(true);
      setStatusModalMesssage("Winner has already been declared");
      return;
    } else if (pickStatus == "0") {
      setShowStatusModal(true);
      setStatusModalMesssage("Sorry, the picks are not open yet.");
      return;
    } else if (
      [2].includes(
        eventGameDetailsSelector && eventGameDetailsSelector.events && eventGameDetailsSelector.events.status
      )
    ) {
      setShowStatusModal(true);
      setStatusModalMesssage("Event has ended. So you can no more pick a rider.");
      return;
    } else {
      if (!showRiderSelectionModal) {
        setRiderSelectionModal(true);
        setSelectedRider(rider);
      }
    }
  };

  const closeRiderSelectionModal = () => {
    if (showRiderSelectionModal) setRiderSelectionModal(false);
    // continueNextEvent()
  };

  const openPickedTeamModal = (type?: any) => {
    if (type == "myteam") {
      // setPerformanceDetails(eventGameDetailsSelector?.events?.performance_dtls)
      getYouPicks();
      // getMyTeam()
    }
    setShowPickedTeamModal(true);
  };

  const closePickedTeamModal = () => {
    setShowPickedTeamModal(false);
    setTeamDetails(null);
    setTieBreakerCode(null);
    // setPerformanceDetails(null)
  };

  const onSuccessRiderSelectionVote = (status: boolean) => {
    if (status) {
      submitVoteForRider();
    }
  };
  // Modal functionality end here

  const backToGameListingPage = (e: any) => {
    e.preventDefault();
    history.push(`/event/${eventId}/${performanceId}`);
  };

  const goToLeaderBoardPage = (e: any) => {
    e.preventDefault();
    history.push(`/result/${eventId}/${gameId}`);
  };

  const goToMostPopularPicksPage = () => {
    // history.push(`/result/${eventId}/${performanceId}`)
    history.push(`/most-popular-picks/${eventId}/${performanceId}`);
  };

  const getEventGameDetails = (guestId?: any) => {
    const params: any = {
      event_id: g_id,
      rodeo_event_id: e_id,
      performance_id: p_id,
      game_id: eventListSelector?.game_details.id,
    };
    console.log({ params });
    if (!userDetails) {
      if (guestUserId) {
        params["guest_user_id"] = guestUserId;
      } else if (guestId) {
        params["guest_user_id"] = guestId;
      }
    }
    eventApi.callGetEventGameDetails(
      params,
      (message: string, resp: any) => {
        if (resp) {
          if (resp?.events?.performance_dtls) {
            localStorage.setItem("performanceInfo", JSON.stringify(resp?.events?.performance_dtls));
          }
          setEventGameDetailsSelector(resp);
          setLoginReq(resp?.rodeo_event_dtls?.login_required);
          setPickStatus(resp?.events?.performance_dtls?.rp_start_pick);
          // setPickStatus(resp?.rodeo_event_game_info?.rp_start_pick);
          console.log("api >>>>>>>>>");
          setWinnerDeclared(resp?.events?.winning_declare || 0);
        }
      },
      (message: string) => {
        toast.error(message);
      }
    );
  };

  const openShareModal = (url: any) => {
    closePickedTeamModal();
    setPerformanceDetails(eventGameListSelector[0].performance_dtls);
    setUrl(url);
    setShowShareModal(true);
  };

  const closeShareModal = () => {
    setShowShareModal(false);
    setPerformanceDetails(null);
  };

  const openFanMagModal = () => {
    console.log("openFanMagModal");
    closePickedTeamModal();
    setShowFanMagModal(true);
  };

  const closeFanMagModal = () => {
    setShowFanMagModal(false);
  };

  useEffect(() => {
    if (g_id) {
      console.log({ g_id });
      getEventGameDetails();
    }
  }, [g_id]);
  // }, [fromRoute,g_id])

  // useEffect(() => {
  //     if (guestUserId)
  //     {
  //         console.log(guestUserId)
  //     }
  // }, [guestUserId])

  //Get localstorage game ids
  useEffect(() => {
    if (localStorage.getItem(RODEPICK_NEXT_GAME_IDS)) {
      let ids = localStorage.getItem(RODEPICK_NEXT_GAME_IDS)?.split(",");
      setNextGameIds(ids);
    }
  }, []);

  //Socket Implementation start here
  const [socket] = useSocket(SOCKET_URL, {
    autoConnect: false,
  });

  // useEffect(() => {

  //     socket.connect();

  //     socket.on(SOCKET_CHANNEL.START_EVENT, (changeEventStatus: any) => {
  //         if(changeEventStatus && changeEventStatus.status==2 && guestUserId)
  //         {
  //             setShowGuestSaveVoteModal(true)
  //         }
  //     })

  //     return () => {
  //         socket.disconnect()
  //     }
  // },[socket])

  useEffect(() => {
    if (userDetails) {
      socket.connect();

      socket.on(SOCKET_CHANNEL.VOTE_RIDER, (riders: any) => {
        eventAction.pushRiderWithVoteDetailsSocketDataIntoRiderList(riders);
      });

      socket.on(SOCKET_CHANNEL.START_EVENT, (changeEventStatus: any) => {
        eventAction.pushGameStatusChangeSocketDataIntoGameDetails(changeEventStatus, userDetails.id);
        if (changeEventStatus && changeEventStatus.status === 0 && changeEventStatus.id === g_id) {
          history.push(`/event/${eventId}/${performanceId}`);
        }
      });

      //Status Message Change Socket
      // socket.on(SOCKET_CHANNEL.STATUS_MESSAGE, (statusMessage: any) => {
      //     console.log({statusMessage})
      //     eventAction.pushGameStatusMessageSocketDataIntoStatusList(statusMessage, userDetails.id)
      // });
    }

    return () => {
      socket.disconnect();
    };
  }, []);

  useEffect(() => {
    socket.connect();

    socket.on(SOCKET_CHANNEL.START_STOP_RP_EVENT, (data: any) => {
      // console.log({data})
      setPickStatus(data.rp_start_pick);
    });

    socket.on(SOCKET_CHANNEL.LOGIN_REQUIRED, (data: any) => {
      // console.log(data)
      if (
        e_id == data.rodeo_event_id &&
        gameDetails &&
        Object.keys(data.login_required).includes(String(gameDetails.id))
      ) {
        setLoginReq(data.login_required[gameDetails.id]);
      }
    });

    socket.on(SOCKET_CHANNEL.CONTESTANT_WINNER, (data: any) => {
      console.log(e_id, data.rodeo_event_id, data.performance_id, p_id, data.rodeo_event_event_id, g_id);
      // const p = useParams<any>();
      console.log(data);
      setContestWinData(data);
      // if (e_id == data.rodeo_event_id && data.performance_id == p_id && data.rodeo_event_event_id == g_id) {
      //   console.log("socket >>>>>>>>>");
      //   setWinnerDeclared(1);
      // }
    });

    return () => {
      socket.disconnect();
    };
  }, []);

  useEffect(() => {
    console.log({ contestWinData });

    if (
      e_id == contestWinData?.rodeo_event_id &&
      contestWinData?.performance_id == p_id &&
      contestWinData?.rodeo_event_event_id == g_id
    ) {
      console.log("socket >>>>>>>>>");
      setWinnerDeclared(1);
      if (eventGameDetailsSelector?.events?.riders && contestWinData) {
        let x = eventGameDetailsSelector?.events?.riders?.map((r: any) => {
          if (r.id == contestWinData?.contestant_id) {
            return { ...r, is_winner: r.is_winner == 1 ? 0 : 1 };
          } else {
            return r;
          }
        });
        console.log({ x });
        setEventGameDetailsSelector({
          ...eventGameDetailsSelector,
          events: { ...eventGameDetailsSelector.events, riders: x },
        });
      }

      setContestWinData(null);
    }
  }, [contestWinData, e_id, p_id, g_id, eventGameDetailsSelector]);

  useEffect(() => {
    let currentIndex: any = nextGameIds.findIndex((x: any) => x == g_id);
    let nextIndex: any = (currentIndex + 1) % nextGameIds.length;
    setNextGameArrayIndex(nextIndex);
  }, [eventGameDetailsSelector]);

  const continueNextEvent = () => {
    let currentIndex: any = nextGameIds.findIndex((x: any) => x == g_id);
    let nextIndex: any = (currentIndex + 1) % nextGameIds.length;
    let nextGameId: number = parseInt(nextGameIds[nextIndex]);
    console.log({ currentIndex, nextIndex, nextGameId });
    if (nextIndex != 0) {
      let generateGameEncryptId = cryptr.encrypt(nextGameId);
      eventAction.emptyGameDetails();
      eventAction.fromRouteHandler(nextGameId);
      console.log("navigate >>>>>>>>>");
      setWinnerDeclared(0);
      // history.replace('');
      history.push(`/event/${eventId}/${performanceId}/${generateGameEncryptId}`);
    } else {
      getEventGameDetails();
    }
  };

  useEffect(() => {
    if (userDetails || loginReq == 0) {
      // history.push(`/event/${eventId}/${gameId}`)
    } else {
      history.push(`${URLS.LOGIN}`);
    }
  }, [loginReq]);

  useEffect(() => {
    if (riderSelectionModalClosed && eventGameListSelector?.length) {
      let team: any = [];
      // console.log({eventGameListSelector})
      eventGameListSelector?.map((x: any) => {
        // console.log({x})
        if (x.ispicked) {
          let y = x.ispicked;
          y["event_name"] = x.event_name;
          y["rider"] = x?.riders?.find((r: any) => r.id == y.rider_id)?.name;
          // console.log({y})
          team.push(y);
        }
      });
      setTeamDetails(team);
      setRiderSelectionModalClosed(false);
      if (team?.length == eventGameListSelector?.length && !congratsShown) {
        // console.log("OpenTeamModal")
        setCongratsShown(true);
        openPickedTeamModal();
        getEventGameDetails();
        return;
      }
      continueNextEvent();
      // setRiderSelectionModalClosed(false)
    }
  }, [riderSelectionModalClosed, eventGameListSelector]);

  useEffect(() => {
    console.log({ eventGameListSelector });
    if (eventGameListSelector?.length) {
      let f = 0;
      eventGameListSelector?.map((evt: any) => {
        if (!evt?.ispicked) {
          f = 1;
        }
      });
      if (f == 0) {
        setCongratsShown(true);
      }
    }
  }, [eventGameListSelector]);

  return (
    <React.Fragment>
      <GeoLocation />
      <h2 className="top-two-btns has-leaderboard" style={{ justifyContent: "center", margin: "0px" }}>
        {/* <Link to="#" className="back-history" onClick={(e) => backToGameListingPage(e)}>
                    <img src="/images/left-white.svg" alt="" />
                </Link> */}
        <a className="back-history" style={{ margin: "0px" }}>
          <span style={{ margin: "0px" }}>
            {/* {
                            eventGameDetailsSelector && eventGameDetailsSelector.events && eventGameDetailsSelector.events.rodeo_pick_event ? eventGameDetailsSelector.events.rodeo_pick_event.title : '...'
                        } */}
            {eventGameDetailsSelector && eventGameDetailsSelector.events && eventGameDetailsSelector.events.event_name
              ? eventGameDetailsSelector.events.event_name
              : "..."}
          </span>
        </a>
        {/* <Link to="#" className="dual-btn" onClick={(e) => goToLeaderBoardPage(e)}>
                    Results
                </Link> */}
        {/* <Link to="#" className="dual-btn" onClick={(e) => backToGameListingPage(e)}>
                    Events
                </Link> */}
      </h2>
      <hr className="color-white" />
      <div className="ready-msg-wrap">
        {/* {
                    getEventStatusText(eventGameDetailsSelector && eventGameDetailsSelector.events && eventGameDetailsSelector && eventGameDetailsSelector.events.status)
                } */}
        Pick your favorite to win
      </div>
      {eventGameDetailsSelector && eventGameDetailsSelector.events && eventGameDetailsSelector.events.sponsor ? (
        <div className="sponsor-img-wrap">
          <img
            src={
              eventGameDetailsSelector &&
              eventGameDetailsSelector.events &&
              eventGameDetailsSelector.events.sponsor &&
              eventGameDetailsSelector.events.sponsor.sponsor &&
              eventGameDetailsSelector.events.sponsor.sponsor.original
            }
            alt={`Sponsor-${
              eventGameDetailsSelector && eventGameDetailsSelector.events && eventGameDetailsSelector.events.sponsor
                ? eventGameDetailsSelector.events.sponsor.title
                : "image"
            }`}
          />
        </div>
      ) : null}

      <div className="score-range-wrap rider-list">
        <h4>
          <span>List of Riders</span>
          {/* <span>Vote Received(%)</span> */}
        </h4>
        <ul className="cons-list">
          {eventGameDetailsSelector &&
          eventGameDetailsSelector.events &&
          eventGameDetailsSelector.events.riders &&
          eventGameDetailsSelector.events.riders.length ? (
            eventGameDetailsSelector.events.riders.map((rider: any) => (
              <li
                key={rider.id}
                className={clsx({
                  "add-check selected":
                    eventGameDetailsSelector.events.ispicked &&
                    eventGameDetailsSelector.events.ispicked.rider_id === rider.id,
                })}
              >
                <Link to="#" onClick={(e) => openRiderSelectionModal(e, rider)}>
                  <span className="name-img">
                    <em className="user-img-wrap">
                      <img
                        src={
                          rider && rider.rider && rider.rider.id
                            ? rider?.rider?.original
                            : rider?.contestant_dtls?.avatar?.original
                        }
                        alt={rider.name}
                      />
                    </em>
                    <div>{rider.name}</div>
                  </span>
                  <span className="count-vote">
                    {rider?.is_winner == 1 ? (
                      <>
                        {/* <i className="fas fa-crown" /> */}
                        <img src="/images/crown.png" />
                      </>
                    ) : null}
                    {/* {
                      rider && (eventGameDetailsSelector.events && eventGameDetailsSelector.events.ispicked ? removeTrailingZero(rider.vote) : '-')
                  } */}
                  </span>
                </Link>
              </li>
            ))
          ) : (
            <li className="no-rider">No riders added yet!</li>
          )}
        </ul>
      </div>
      {nextGameArrayIndex == 0 ? (
        <div className="join-now-btn-wrap">
          <button type="submit" onClick={goToMostPopularPicksPage}>
            See the most popular picks
          </button>
        </div>
      ) : (
        <div className="join-now-btn-wrap">
          <button type="submit" onClick={continueNextEvent}>
            Continue to next event
          </button>
        </div>
      )}

      <div className="d-flex align-items-center">
        <Link to="#" className="back-events w-50" onClick={(e) => backToGameListingPage(e)}>
          <img src="/images/left-white.svg" alt="back" />
          Event List
        </Link>

        <a className="rkmd-btn btn-lg btn-orange w-50 m-2" onClick={() => openPickedTeamModal("myteam")}>
          Your picks
        </a>
      </div>

      <Sponsor />

      {showRiderSelectionModal && (
        <RiderSelectionModal
          onClose={closeRiderSelectionModal}
          onSuccess={onSuccessRiderSelectionVote}
          shouldShow={showRiderSelectionModal}
          riderDetails={selectedRider}
        />
      )}

      {/* {
                showGuestSaveVoteModal &&
                <GuestSaveVoteModal
                    onClose={closeGuestSaveVoteModal}
                    onSuccess={onSuccessGuestSaveVoteModal}
                    shouldShow={showGuestSaveVoteModal}
                />
            } */}
      {showStatusModal && statusModalMesssage && (
        <StatusModal shouldShow={showStatusModal} onClose={onStatusModalClose} message={statusModalMesssage} type={1} />
      )}

      {showPickedTeamModal && teamDetails?.length && !performanceDetails && (
        // showPickedTeamModal && teamDetails?.length &&
        <PickedTeamModal
          shouldShow={showPickedTeamModal}
          onClose={closePickedTeamModal}
          teamDetails={teamDetails}
          openShareModal={openShareModal}
          tieBreakerCode={tieBreakerCode}
          openFanMagModal={openFanMagModal}
        />
      )}

      {showPickedTeamModal && teamDetails?.length && performanceDetails && (
        <PickedTeamModal
          shouldShow={showPickedTeamModal}
          onClose={closePickedTeamModal}
          teamDetails={teamDetails}
          performanceDetails={performanceDetails}
          openShareModal={openShareModal}
          openFanMagModal={openFanMagModal}
        />
      )}

      {showShareModal && performanceDetails && url && (
        <ShareModal
          shouldShow={showShareModal}
          onClose={closeShareModal}
          performanceDetails={performanceDetails}
          url={url}
        />
      )}
      {showFanMagModal && <FanMagazineModal onClose={closeFanMagModal} shouldShow={showFanMagModal} />}
    </React.Fragment>
  );
}
